import React, { ReactElement } from "react";
import HubProductList from "../../../components/Hubs/Products";
import Layout from "../../../components/layout";

const HubProductPage = (): ReactElement => {
  return (
    <Layout>
      <HubProductList />
    </Layout>
  );
};

export default HubProductPage;
